import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'vnm-help-tip',
  templateUrl: './help-tip.component.html',
  styleUrls: ['./help-tip.component.scss']
})
export class HelpTipComponent {
  @HostBinding('class.is-help') get isHelp() {
    return !!this.help;
  }

  @Input() help: string;
  @Input() info: string;

  @Output() tooltipClicked = new EventEmitter();
}
